import { Component, Input, OnInit } from '@angular/core';
import { AppSettings, Settings } from 'src/app/app.settings';

@Component({
  selector: 'app-header-video',
  templateUrl: './header-video.component.html',
  styleUrls: ['./header-video.component.scss']
})
export class HeaderVideoComponent implements OnInit {
  @Input('backgroundVideo') backgroundVideo: any;
  @Input('contentOffsetToTop') contentOffsetToTop = false;
  @Input('contentMinHeight') contentMinHeight: any;
  @Input('title') title: any;
  @Input('desc') desc: any;
  @Input('isHomePage') isHomePage = false;
  @Input('fullscreen') fullscreen = false;
  public settings: Settings;
  constructor(public appSettings: AppSettings) {
    this.settings = this.appSettings.settings;
    setTimeout(() => {
      this.settings.headerBgVideo = true;
    });
  }

  ngOnInit(): void {
    if (this.contentOffsetToTop){
      setTimeout(() => {
        this.settings.contentOffsetToTop = this.contentOffsetToTop;
      });
    }
    const vid = document.getElementById('bgVideo') as HTMLVideoElement;
    vid.muted = true;
  }

  ngOnDestroy(){
    setTimeout(() => {
      this.settings.headerBgVideo = false;
      this.settings.contentOffsetToTop = false;
    });
  }

}
